<template>
  <div>
    <div class="my-2">
      <Link class="group flex items-center" href="/">
        <div class="flex items-center transition-all" :class="isUrl('') ? 'bg-white flex py-3 px-12 w-full' : 'hover:bg-white w-full flex py-3 px-12'">
          <HeroIcon name="homeoffice" class="mr-2 w-5 h-5" :class="isUrl('') ? 'fill-orfBlue-100' : 'fill-white group-hover:fill-orfBlue-100'" />
          <div :class="isUrl('') ? 'text-orfBlue-100' : 'text-white group-hover:text-orfBlue-100'">Dashboard</div>
        </div>
      </Link>
    </div>
    <div class="my-2">
      <Link class="group flex items-center" href="/events">
        <div class="flex items-center transition-all" :class="isUrl('events') ? 'bg-white flex py-3 px-12 w-full' : 'hover:bg-white w-full flex py-3 px-12'">
          <HeroIcon name="rectangle-stack" class="mr-2 w-5 h-5" :class="isUrl('events') ? 'fill-orfBlue-100' : 'fill-white group-hover:fill-orfBlue-100'" />
          <div :class="isUrl('events') ? 'text-orfBlue-100' : 'text-white group-hover:text-orfBlue-100'">Termine</div>
        </div>
      </Link>
    </div>
    <hr/>
    <div class="my-2">
      <Link class="group flex items-center" href="/teams">
        <div class="flex items-center transition-all" :class="isUrl('teams') ? 'bg-white flex py-3 px-12 w-full' : 'hover:bg-white w-full flex py-3 px-12'">
          <HeroIcon name="flag" class="mr-2 w-5 h-5" :class="isUrl('teams') ? 'fill-orfBlue-100' : 'fill-white group-hover:fill-orfBlue-100'" />
          <div :class="isUrl('teams') ? 'text-orfBlue-100' : 'text-white group-hover:text-orfBlue-100'">Teams</div>
        </div>
      </Link>
    </div>
    <div class="my-2">
      <Link class="group flex items-center" href="/users">
        <div class="flex items-center transition-all" :class="isUrl('users') ? 'bg-white flex py-3 px-12 w-full' : 'hover:bg-white w-full flex py-3 px-12'">
          <HeroIcon name="people" class="mr-2 w-5 h-5" :class="isUrl('users') ? 'fill-orfBlue-100' : 'fill-white group-hover:fill-orfBlue-100'" />
          <div :class="isUrl('users') ? 'text-orfBlue-100' : 'text-white group-hover:text-orfBlue-100'">Mitarbeiter</div>
        </div>
      </Link>
    </div>
    <hr/>
    <div class="my-2">
      <Link class="group flex items-center" href="/help">
        <div class="flex items-center transition-all" :class="isUrl('help') ? 'bg-white flex py-3 px-12 w-full' : 'hover:bg-white w-full flex py-3 px-12'">
          <HeroIcon name="help" class="mr-2 w-5 h-5" :class="isUrl('help') ? 'fill-orfBlue-100' : 'fill-white group-hover:fill-orfBlue-100'" />
          <div :class="isUrl('help') ? 'text-orfBlue-100' : 'text-white group-hover:text-orfBlue-100'">Hilfe</div>
        </div>
      </Link>
    </div>
  </div>
</template>

<script>
import { Link } from '@inertiajs/inertia-vue3'
import HeroIcon from '@/Shared/HeroIcon.vue'

export default {
  components: {
    HeroIcon,
    Link,
  },
  methods: {
    isUrl(...urls) {
      let currentUrl = ''
      if (this.$page.url.indexOf('/?') != -1) {
        currentUrl = this.$page.url.substr(0, this.$page.url.indexOf('/?'))
      } else {
        currentUrl = this.$page.url.substr(1)
      }
      if (urls[0] === '') {
        return currentUrl === ''
      }
      return urls.filter((url) => currentUrl.startsWith(url)).length
    },
  },
}
</script>
